import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { PendingAreaContentService } from './pending-area-content.service';

import { PendingAreaContent } from '@core/models/pending-area-content.model';

@Injectable({ providedIn: 'root' })
export class PendingAreaContentResolver {
  constructor(private service: PendingAreaContentService) {}

  public resolve(): Observable<PendingAreaContent[]> {
    return this.service.fetchPendingAreaContent();
  }
}
